import React from "react";

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const data = payload[0];

        return (
            <div className="bg-white-A700 shadow-lg border rounded-md p-1 text-xs">
                <p className="font-semibold text-gray-700">{data.name}</p>
                <p className="text-blue-600">
                    Amount: ₹{data.value}
                </p>
            </div>
        );
    }

    return null;
};

export default CustomTooltip;